import { Controller } from "stimulus";
import { csrfToken } from "../lib/http";

/**
 * Base class for all JavaScript Controllers.
 *
 * https://stimulusjs.org/handbook
 */
export default class extends Controller {
    // connect()
    // disconnect()

    /**
     * Dispatch an event from this controller.
     *
     * The controller identifier will be prefixed to the event. For example,
     * a controller named `foo-bar` might call `dispatch` with `baz`, which
     * would dispatch a custom event named `foo-bar:baz`.
     *
     * By default the event will bubble up such that parent controllers can
     * listen.
     *
     * @param {String} eventName
     * @param {Object} options
     */
    dispatch(eventName, { target = this.element, detail = {}, bubbles = true, cancelable = true } = {}) {
        const type = `${this.identifier}:${eventName}`;
        const event = new CustomEvent(type, { detail, bubbles, cancelable });
        target.dispatchEvent(event);
        return event;
    }

    get fetchOptions() {
        return {
            headers: this.fetchHeaders,
            credentials: "same-origin",
            redirect: "follow"
        };
    }

    get fetchHeaders() {
        return {
            "X-Requested-With": "XMLHttpRequest",
            "X-CSRF-Token": csrfToken()
        };
    }
}
